<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light rounded">
        <div class="container-fluid">
            <div class=" p-0 m-0">
                <a class="navbar-brand ff-l1 fs-5" @click="$router.push({ name: 'home' })" role="button">
                    <i class="bi bi-scissors me-1"></i>{{ userStore.tenant.name }}
                    <!-- <div class="ff-l3 fw-bold fs-6"><small>{{ userStore.tenant.name }}</small></div> -->
                </a>
                <!-- <span class="badge bg-secondary" role="button" @click="$router.push({name:'atelier.view'})"><i class="bi bi-info"></i></span> -->
            </div>
            <button class="navbar-toggler btn-xs" type="button" ref="btnToggleNav" data-bs-toggle="collapse"
                data-bs-target="#navMenu">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navMenu">
                <div class="row p-1 bg-error my-2 d-md-none">
                    <div class="col d-flex justify-content-start align-items-center">
                        <span class="bg-body text-black btn" role="button" @click="$router.push({ name: 'auth-user' })">
                            <i class="bi bi-person"></i>
                            {{ userStore.$state.user.name }} {{ userStore.$state.user.prenoms }}
                        </span>
                    </div>
                    <div class="col d-flex align-items-center justify-content-end">
                        <div>
                            <span class="btn btn-info" role="button" @click="logout">
                                <i class="bi bi-box-arrow-left"></i>
                                Déconnexion
                            </span>
                        </div>
                    </div>
                </div>
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li v-for="link in links" :key="link.name" class="nav-item" @click="goToLink({ name: link.name })"
                        role="button">
                        <p class="mx-1"><i :class="'bi ' + link.icon + ' me-1'"></i>{{ link.label }}</p>
                    </li>
                </ul>
                <div class="d-none d-md-block">
                    <!-- Example single danger button -->
                    <div class="dropdown">
                        <a class="btn btn-info dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <span>
                                <span class="rounded bg-info p-2"><i class="bi bi-person"></i></span>
                                {{ userStore.$state.user.name }} {{
                                    userStore.$state.user.prenoms
                                }}
                            </span>
                        </a>

                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <li><a class="dropdown-item" role="button" @click="$router.push({ name: 'auth-user' })"><i
                                        class="bi bi-person"></i> Profil</a></li>
                            <li>
                                <hr class="dropdown-divider">
                            </li>
                            <li><a class="dropdown-item" role="button" @click="logout"> <i
                                        class="bi bi-box-arrow-left"></i> Deconnexion</a></li>
                        </ul>
                    </div>

                </div>
                <div class="mx-4"></div>
            </div>
        </div>
    </nav>
</template>

<script>
import { useUserStore } from '@/store/userStore';

export default {
    name: "Nav",
    data() {
        return {
            links: [
                { name: 'home', icon: 'bi-house', label: 'Accueil' },
                { name: 'tissu_types.index', icon: 'bi-list', label: 'Type tissus' },
                { name: 'catalogues.index', icon: 'bi-collection', label: 'Catalogue' },
                { name: 'orders.index', icon: 'bi-border-style', label: 'Commandes' },
                { name: 'users.index', icon: 'bi-people', label: 'Utilisateurs' },
                { name: 'wallets.view', icon: 'bi-wallet', label: 'Portefeuille' },
                { name: 'atelier.view', icon: 'bi-info', label: 'A propos' },
            ]

        }
    },
    computed: {
        userStore: () => useUserStore()
    },
    methods: {
        logout() {
            this.$api.post('auth/logout')
                .then(() => {
                    this.userStore.removeAuthData();
                    this.$router.push({ name: 'login' })
                })
                .catch(() => {

                })
        },
        goToLink(link) {
            if (window.innerWidth < 992) {
                this.$refs.btnToggleNav?.click();
            }
            this.$router.push(link);
        }
    }
}
</script>